import { makeStyles } from '@material-ui/core';
import { rem, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(theme => ({
  container: {
    textAlign: 'center',
    background: themeColor.white,
    border: `1px solid ${themeColor.secondaryLight}`,
    color: themeColor.tangaroa,
  },
  loyaltyContainerWrapper: {
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  titleBarWrapper: {
    justifyContent: 'space-around',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    border: 'none',
    '& button': {
      boxShadow: 'none',
    },
  },
  removeReplaceWrapper: {
    background: 'white',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '0.73vw',
    width: '100%',
    paddingLeft: '0.8vw',
    paddingRight: '0.8vw',
    borderBottom: `1px solid ${themeColor.secondaryLight}`,
    '& button': {
      color: `${themeColor.defaultTextColor}`,
      marginTop: '1.37vh',
      marginBottom: '1.37vh',
      height: '7.29vh',
      width: '10.24vw',
    },
    '& p': {
      marginTop: '0.26vh',
      fontWeight: 500,
      fontSize: vh(1.825),
    },
    '& hr': {
      backgroundColor: `${themeColor.secondaryLight}`,
      width: '100%',
    },
  },
  buttonIcons: {
    color: `${themeColor.subheaderLight}`,
  },
  loyaltyTitleButton: {
    padding: `1.3vh 0 1.3vh 0.732vw`,
    flexWrap: 'nowrap',
    alignItems: 'center',
    cursor: 'pointer',
    border: 'none',
    height: '100%',
    fontSize: vh(1.825),
    flexGrow: 1,
    color: themeColor.subheaderLight,
    minHeight: '1px;',
    '&:hover': {
      backgroundColor: theme.palette.primary.contrastText,
    },
  },
  loyaltyTitleButtonLabel: {
    paddingLeft: 0,
  },
  loyaltyTitle: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    wordBreak: 'break-word',
    textTransform: 'uppercase',
    alignItems: 'center',
  },
  loyaltyIcon: {
    display: 'flex',
    marginRight: '0.732vw',
    alignItems: 'center',
  },
  loyaltyIconRotated: {
    transform: 'rotate(180deg)',
  },
  loyaltySelectedFont: {
    color: themeColor.subheaderLight,
    fontSize: rem(1),
    fontWeight: 500,
    lineHeight: rem(1.14),
    letterSpacing: rem(0.0357),
  },
  loyaltyItemsContainer: {
    width: 'auto',
    padding: '1.3vh 0.732vw 1.3vh 0',
  },
  loyaltySearchButton: {
    flexGrow: 0,
    justifySelf: 'flex-end',
    width: vh(7.01),
    height: '100%',
    minWidth: vh(7.01),
    border: 'none',
    borderLeft: `1px solid ${themeColor.secondaryLight}`,
    borderRadius: '0',
    color: themeColor.subheaderLight,
    padding: 0,
    minHeight: '1px;',
    '@media (max-height: 768px)': {
      minWidth: '49px',
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.contrastText,
    },
  },
  itemCountButton: {
    border: 'none',
    height: '100%',
    width: 'auto',
    flexGrow: 1,
    justifyContent: 'flex-end',
  },
  loyaltySearch: {
    position: 'relative',
    height: '100%',
    width: vh(7.01),
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    '& svg': {
      position: 'absolute',
      cursor: 'pointer',
    },
  },
  loyaltyDetails: {
    margin: '0',
    textAlign: 'left',
    fontSize: vh(1.825),
    lineHeight: vh(2),
    fontWeight: 500,
    width: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  loyaltyPoints: {
    fontWeight: 400,
    color: themeColor.subheaderLight,
  },
}));
